import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { apiClient } from "src/utils/Api/apiClient";

interface adapterUpdatState {
        updateList: [];
        updateDone: boolean;
        updateListLoading: boolean;
        updateListError: string | null;
}

const initialState: adapterUpdatState = {
        updateList: [],
        updateDone: false,
        updateListLoading: false,
        updateListError: null
}

// export const createEndUserInstanceLocation = createAsyncThunk(
//         'endUserInstanceLocation/createEndUserInstanceLocation',
//         async (endUserInstanceLocationData: any, { rejectWithValue }) => {
//                 try {
//                         const response = await apiClient.post('endUserInstanceLocation/createEndUserInstanceLocation', endUserInstanceLocationData);
//                         return response.data;
//                 } catch (endUserInstanceLocationError: any) {
//                         return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
//                 }
//         }
// );
//

export const updateAdapter = createAsyncThunk(
        'adapterUpdate/updateAdapter',
        async (updateAdapterData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('adapterUpdate/updateAdapter', updateAdapterData).then();
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

export const getUpdateList = createAsyncThunk(
        'adapterUpdate/getUpdateList',
        async (updateListData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`adapterUpdate/getUpdateList/`);
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

const adapterUpdateSlice = createSlice({
        name: 'adapterUpdate',
        initialState,
        reducers: {
                adapterUpdateReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add endUsers to server
                // builder.addCase(createEndUserInstanceLocation.pending, (state) => {
                //         state.endUserInstanceLocationLoading = true;
                //         state.endUserInstanceLocationError = null;
                // });
                // builder.addCase(createEndUserInstanceLocation.fulfilled, (state, action) => {
                //         state.endUserInstanceLocationLoading = false;
                //         state.endUserInstanceLocation = action.payload;
                // });
                // builder.addCase(createEndUserInstanceLocation.rejected, (state, action) => {
                //         state.endUserInstanceLocationLoading = false;
                //         state.endUserInstanceLocationError = action.payload as string;
                // });
                //update endUsers to server
                builder.addCase(updateAdapter.pending, (state) => {
                        state.updateListLoading = true;
                        state.updateListError = null;
                });
                builder.addCase(updateAdapter.fulfilled, (state, action) => {
                        state.updateListLoading = false;
                        state.updateDone = action.payload;
                });
                builder.addCase(updateAdapter.rejected, (state, action) => {
                        state.updateListLoading = false;
                        state.updateListError = action.payload as string;
                });
                //get endUsers by ID from server
                builder.addCase(getUpdateList.pending, (state) => {
                        state.updateListLoading = true;
                        state.updateListError = null;
                });
                builder.addCase(getUpdateList.fulfilled, (state, action) => {
                        state.updateListLoading = false;
                        state.updateList = action.payload;
                });
                builder.addCase(getUpdateList.rejected, (state, action) => {
                        state.updateListLoading = false;
                        state.updateListError = action.payload as string;
                });
        }
});

export const { adapterUpdateReset } = adapterUpdateSlice.actions;
export default adapterUpdateSlice.reducer;
